import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    autoComplete: {
      '& .MuiAutocomplete-inputRoot': {
        height: 'auto',
      },
      '& .MuiFormControl-root': {
        minWidth: 255,
      },
      '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        padding: '0 14px',
      },

      '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        minWidth: 72,
        background: 'transparent',
        marginRight: 20,
      },
    },
    moreText: {
      margin: 3,
      maxWidth: 'calc(100% - 6px)',
      color: palette.blue,
    },
    endAdornment: {
      position: 'absolute',
      right: 14,

      '& svg': { color: palette.red, fontSize: 15, cursor: 'pointer' },
    },
  });
